// router.js
import { createRouter, createWebHistory } from 'vue-router';

import DashboardScreen from './pages/DashboardScreen.vue';
import LoginScreen from './pages/LoginScreen.vue';

import EmployeesScreen from "./pages/EmployeesScreen.vue";
import UsersScreen from "./pages/UsersScreen.vue";

import KycRequestsScreen from "./pages/KycRequestsScreen.vue";
import WithdrawalsScreen from "./pages/WithdrawalsScreen.vue";
import RepaymentsScreen from "./pages/RepaymentsScreen.vue";

import SystemSettingsScreen from "./pages/SystemSettingsScreen.vue";
import AuditLogsScreen from "./pages/AuditLogsScreen.vue";
import CreditRequests from "./pages/CreditRequests.vue";
import AdminNotificationList from "./pages/AdminNotificationList.vue";


const routes = [
  {
    path: "/",
    name: "DashboardScreen",
    component: DashboardScreen,
  },
  {
    path: "/login",
    name: "LoginScreen",
    component: LoginScreen,
  },
   {
    path: "/noties",
    name: "AdminNotificationList",
    component: AdminNotificationList,
  },
 {
    path: "/credit_requests",
    name: "CreditRequests",
    component: CreditRequests,
  },
  {
    path: "/employees",
    name: "EmployeesScreen",
    component: EmployeesScreen,
  },
  {
    path: "/users",
    name: "UsersScreen",
    component: UsersScreen,
  },
  {
    path: "/kyc",
    name: "KycRequestsScreen",
    component: KycRequestsScreen,
  },
  {
    path: "/withdrawals",
    name: "WithdrawalsScreen",
    component: WithdrawalsScreen,
  },
  {
    path: "/repayments",
    name: "RepaymentsScreen",
    component: RepaymentsScreen,
  },
  {
    path: "/system",
    name: "SystemSettingsScreen",
    component: SystemSettingsScreen,
  },
  {
    path: "/audit",
    name: "AuditLogsScreen",
    component: AuditLogsScreen,
  },
];


const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const ldataRaw = sessionStorage.getItem('ldata');
  const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
 
  
  if (!to.path.includes("login") && !ldata) {
    return next("/login");
  }

  if (to.path.includes("login") && ldata) {
    return next("/");
  }
  next();
});



export default router;
